import React, { useState } from 'react';
import { useSelector, batch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import { RootStateOrAny, store } from '../../store';
import { discardProjectChanges, saveProjectFile } from 'src/api';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  longTaskComplete,
  longTaskStarted,
  uiSet,
  unloadProject,
} from './mainframe.reducer';
import additionalMessages from '../../messages';
import { runWithConfirmation } from 'src/utils/useful_functions';
import NewProjectDialog from '../project/NewProjectDialog';
import linkPlannerIcon from '../../../src/images/linkplanner-coloured.svg';

const doSave = (projectId) => {
  batch(() => {
    store.dispatch(uiSet({ locked: true }));
    store.dispatch(
      longTaskStarted({
        heading: 'Saving project',
        message: 'This may take a while',
      })
    );
  });
  saveProjectFile(projectId)
    .then((res) => {
      store.dispatch(
        uiSet({
          projectId: res.id,
          projectName: res.name,
          projectModified: false,
        })
      );
    })
    .catch((err) => {
      console.error(err);
      store.dispatch(uiSet({ locked: false }));
    })
    .finally(() => {
      store.dispatch(longTaskComplete());
    });
};

export const FileMenu = (props) => {
  const [openNewProjectPopup, setOpenNewProjectPopup] = useState(false);
  return (
    <>
      <Dropdown
        title=""
        text="Projects"
        floating
        labeled
        className="mr-2"
        icon={{ name: '' }}
      >
        <Dropdown.Menu>
          <FileMenuList
            setOpenNewProjectPopup={setOpenNewProjectPopup}
            {...props}
          />
        </Dropdown.Menu>
      </Dropdown>
      <NewProjectDialog
        isOpen={openNewProjectPopup}
        onClose={() => setOpenNewProjectPopup(false)}
      />
    </>
  );
};

const FileMenuList = (props) => {
  const { projectId, projectName, projectModified, permissionWrite, loggedIn } =
    useSelector((state: RootStateOrAny) => state.mainFrame);
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const { pathname } = useLocation();

  const { setOpenNewProjectPopup } = props;

  let iconColour = 'grey';

  if (permissionWrite && projectId) {
    if (projectModified) {
      // TODO: Handle when the project has been modified
      iconColour = 'red';
    } else if (loggedIn) {
      iconColour = 'black';
    }
  }

  const openNewProjectPopup = () => {
    setOpenNewProjectPopup(true);
  };

  const openImportProjectPopup = () => {
    store.dispatch(uiSet({ showLPImportDialog: true }));
  };

  const discardChanges = (e) => {
    //const { projectId } = props;
    runWithConfirmation({
      header: `${formatMessage(
        additionalMessages.discardChanges
      )}: ${projectName}`,
      onConfirm: () => {
        store.dispatch(uiSet({ locked: true }));
        discardProjectChanges(projectId)
          .then(() => {
            store.dispatch(unloadProject());
            if (pathname !== '/projects') {
              navigate('/projects');
            }
          })
          .catch((err) => {
            console.error(err);
            store.dispatch(uiSet({ locked: false }));
          });
      },
    });
  };

  return (
    <>
      <Dropdown.Item
        text="New"
        icon={{ name: 'plus square outline' }}
        onClick={() => openNewProjectPopup()}
        title="Create a new project"
      ></Dropdown.Item>
      <Dropdown.Item
        text="Import LINKPlanner Project File"
        image={{
          src: linkPlannerIcon,
          style: { height: '13px', marginTop: '-1px' },
        }}
        onClick={() => openImportProjectPopup()}
        title="Import a LINKPlanner v5 project file"
      ></Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item
        text="Project List"
        icon={{ name: 'folder open outline' }}
        onClick={() => navigate('/projects')}
        title="Open an existing project"
      ></Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item
        title="Save changes to the current project"
        icon={{
          name: 'save',
          color: iconColour,
        }}
        onClick={() => doSave(projectId)}
        text="Save"
        disabled={!(loggedIn && permissionWrite) || !projectModified}
      />
      <Dropdown.Divider />
      <Dropdown.Item
        title="Discard changes made to the current project"
        icon={{
          name: 'history',
          color: iconColour,
        }}
        onClick={discardChanges}
        text="Discard Changes"
        disabled={!(loggedIn && permissionWrite) || !projectModified}
      />
    </>
  );
};
